'use strict'
var twentyninetimes = twentyninetimes || {}

twentyninetimes.blockHero = twentyninetimes.blockHero || (function () {
    function init() {
      const hero = document.querySelector('.block-hero.video');

      if ( !hero ) return;

      const figure = hero.querySelector('figure');
      const button = hero.querySelector('.js-hero-video-toggle');
      let video_params = '?autoplay=1&playsinline=1&controls=0&disablekb=1&fs=0';
      const video_url = button.getAttribute('data-video-url');

      // Detect if the user is on an iOS device
      if (isIOS()) {
        video_params += '&mute=1'; // Add mute parameter for iOS
      }

      button.addEventListener('click', function (e) {
        e.stopPropagation();

        if ( !hero.classList.contains('has-iframe') ) {
          if ( window.CookieInformation && window.CookieInformation.getConsentGivenFor('cookie_cat_marketing') ) {
            createIframe(video_url + video_params, figure, hero);
          } else {
            if (!figure.querySelector('.video-consent-text')) {
              var viewConsentText = document.createElement('div')
              var button = this;
              viewConsentText.setAttribute('class', 'video-consent-text'),
                (viewConsentText.innerHTML =
                  '<div><p>Cookies skal være accepteret for at kunne afspille denne video.</p><button class="btn video-consent-approve">Giv tilladelse og afspil</button></div>')
              figure.appendChild(viewConsentText)
              viewConsentText
                .querySelector('.video-consent-approve')
                .addEventListener('click', function (e) {
                  console.log('now giving consent')

                  viewConsentText.remove()
                  window.CookieInformation.submitAllCategories()
                  button.click()
                })
            }
          }
        } else {
          var iframe = figure.querySelector('iframe');
          hero.classList.remove('has-iframe');

          setTimeout(function () {
            iframe.remove();
          }, 600);
        }
      });
    }

    function createIframe(src, parent, hero) {
      var iframe = document.createElement('iframe');

      iframe.setAttribute('src', src);
      iframe.setAttribute('frameborder', '0');
      iframe.setAttribute('allow', 'autoplay; fullscreen');
      iframe.setAttribute('allowfullscreen', '');
      iframe.setAttribute('playsinline', '');

      iframe.addEventListener('load', function () {
        hero.classList.add('has-iframe');
      });

      parent.appendChild(iframe);
    }

    // Utility function to detect iOS devices
    function isIOS() {
      return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    }

    return {
      init: init,
    }
  })()
